module.exports = __webpack_public_path__ + "img/import-file-dark.f843f79.svg";